import { ReactNode, useEffect, useState } from "react";
import { IIndicators } from "../../../../types/Indicators.type";
import { getIndicatorById, updateIndicator } from "../../services/indicator.api";
import Loading from "../../../../common/components/ui/loading/Loading";
import { IRenter } from "../../../../types/renter.type"
import {
  IndicatorDashboardContext,
  initialState
} from "../indicator-dashboard/IndicatorDashboard.context";


type Props = {
  children: ReactNode;
  indicatorId: string;
};

export function IndicatorDashBoardProvider({ children, indicatorId }: Props) {
  const [indicator, setIndicator] = useState<IIndicators>(initialState.indicator);
  const [indications, setIndications] = useState<IRenter[]>([])
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function loadIndicator(indicatorId: string) {
      const result = await getIndicatorById(indicatorId);

      if (result.ok) {
        setIndicator(result.data as IIndicators)
        setIndications(result.data.renters as IRenter[])
      }
      setLoading(false);
    }

    loadIndicator(indicatorId);
  }, [indicatorId]);

  async function saveIndicator(dataToSave: IIndicators) {
    try {
      const { ok, data, errors } = await updateIndicator(indicator._id as string, dataToSave);

      if (ok && data) {
        setIndicator(data as IIndicators);
        return { ok, data: data as IIndicators, errors: (errors as [{ message: string; path: string[] }]) };
      }

      return { ok, data: data as IIndicators, errors: errors as [{ message: string, path: string[] }] };
    } catch (err) {
      console.log(err);

      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      };
    }
  }

  const theState = { indicator, saveIndicator, indications }

  return (
    <IndicatorDashboardContext.Provider value={theState}>
      {loading ? <Loading /> : children}
    </IndicatorDashboardContext.Provider>
  );
}
